import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Form,
  FormGroup,
  FormField,
  Checkbox,
  Input,
  Button,
  Dropdown
} from 'semantic-ui-react'

const CardORCaseListUX = (props: any) => {
    return(
      <div
        id="CardORCaseList"
        style={{padding: "15px"}}>
        <Form
          id="CardORCaseListUX-Form-57">
          <FormGroup
            id="CardORCaseListUX-FormGroup-58">
            <FormField
              id="CardORCaseListUX-FormField-60"
              width={3}>
              <Checkbox
                checked={props.ORCaseListSequence?.orFilter?.checkedHn}
                id="CardORCaseListUX-Checkbox-67"
                label={props.languageUX === "en" ? "HN" : "HN"}
                name="checkedHn"
                onChange={props.onChangeFilter}
                style={{marginBottom: "0.5rem"}}>
              </Checkbox>
              <div
                id="CardORCaseListUX-div-70">
                {props.patientSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardORCaseListUX-FormField-61"
              width={3}>
              <label
                id="CardORCaseListUX-label-69">
                {props.languageUX === "en" ? "Patient Name" : "ชื่อ-สกุลผู้ป่วย"}
              </label>
              <Input
                disabled={true}
                fluid={true}
                id="CardORCaseListUX-Input-72"
                style={{opacity: 1}}
                value={props.ORCaseListSequence?.orFilter?.patientFullName || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardORCaseListUX-FormField-62"
              width={3}>
              <Checkbox
                checked={props.ORCaseListSequence?.orFilter?.checkedDate}
                id="CardORCaseListUX-Checkbox-68"
                label={props.languageUX === "en" ? "Date of Surgery" : "วันที่ผ่าตัด"}
                name="checkedDate"
                onChange={props.onChangeFilter}
                style={{marginBottom: "0.5rem"}}>
              </Checkbox>
              <div
                id="CardORCaseListUX-div-71"
                style={{width: "100%"}}>
                {props.startDateTextBox}
              </div>
            </FormField>
            <FormField
              id="CardORCaseListUX-FormField-63">
              <label
                id="CardORCaseListUX-label-73">
                {"\u00a0"}
              </label>
              <label
                id="CardORCaseListUX-label-74"
                style={{height: "100%", display: "flex", alignItems: "center", marginTop: "-0.75rem"}}>
                {props.languageUX === "en" ? "to" : "ถึง"}
              </label>
            </FormField>
            <FormField
              id="CardORCaseListUX-FormField-64"
              width={3}>
              <label
                id="CardORCaseListUX-label-75">
                {"\u00a0"}
              </label>
              <div
                id="CardORCaseListUX-div-76"
                style={{width: "100%"}}>
                {props.endDateTextBox}
              </div>
            </FormField>
            <FormField
              id="CardORCaseListUX-FormField-65"
              width={3}>
              <Checkbox
                checked={props.ORCaseListSequence?.orFilter?.checkedDoctor}
                id="CardORCaseListUX-Checkbox-77"
                label={props.languageUX === "en" ? "Surgeon" : "แพทย์ผ่าตัด"}
                name="checkedDoctor"
                onChange={props.onChangeFilter}
                style={{marginBottom: "0.5rem"}}>
              </Checkbox>
              <div
                id="CardORCaseListUX-div-78"
                style={{width: "100%"}}>
                {props.doctorSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardORCaseListUX-FormField-66"
              style={{minWidth: "max-content"}}>
              <label
                id="CardORCaseListUX-label-108"
                style={{marginBottom: "0.5rem"}}>
                {"\u00a0"}
              </label>
              <Button
                color="yellow"
                id="CardORCaseListUX-Button-79"
                onClick={props.onClear}
                size="small"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Clear" : "ล้างการค้นหา"}
              </Button>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardORCaseListUX-FormGroup-59">
            <FormField
              id="CardORCaseListUX-FormField-80"
              width={4}>
              <Checkbox
                checked={props.ORCaseListSequence?.orFilter?.checkedCase}
                id="CardORCaseListUX-Checkbox-105"
                label={props.languageUX === "en" ? "Case" : "Case"}
                name="checkedCase"
                onChange={props.onChangeFilter}
                style={{marginBottom: "0.5rem"}}>
              </Checkbox>
              <Dropdown
                clearable={true}
                disabled={!props.ORCaseListSequence?.orFilter?.checkedCase}
                fluid={true}
                id="CardORCaseListUX-Dropdown-87"
                multiple={true}
                name="cases"
                onChange={props.onChangeFilter}
                options={[ { key: "is_opd_case", value: "is_opd_case", text: "OPD" }, { key: "is_ipd_case", value: "is_ipd_case", text: "IPD" }, { key: "is_one_day_case", value: "is_one_day_case", text: "One Day", }, ]}
                search={true}
                selection={true}
                style={{minWidth: "100%", width: 0}}
                value={props.ORCaseListSequence?.orFilter?.cases || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardORCaseListUX-FormField-81"
              width={4}>
              <Checkbox
                checked={props.ORCaseListSequence?.orFilter?.checkedLocation}
                id="CardORCaseListUX-Checkbox-106"
                label={props.languageUX === "en" ? "Location" : "Location"}
                name="checkedLocation"
                onChange={props.onChangeFilter}
                style={{marginBottom: "0.5rem"}}>
              </Checkbox>
              <Dropdown
                clearable={true}
                disabled={!props.ORCaseListSequence?.orFilter?.checkedLocation}
                fluid={true}
                id="CardORCaseListUX-Dropdown-88"
                name="operating_detail__operating_room__location_id"
                onChange={props.onChangeLocation}
                options={props.locationOptions || []}
                search={true}
                selection={true}
                style={{minWidth: "100%", width: 0}}
                value={props.ORCaseListSequence?.orFilter?.operating_detail__operating_room__location_id || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardORCaseListUX-FormField-82"
              width={4}>
              <Checkbox
                checked={props.ORCaseListSequence?.orFilter?.checkedRoom}
                id="CardORCaseListUX-Checkbox-107"
                label={props.languageUX === "en" ? "Room" : "ห้อง"}
                name="checkedRoom"
                onChange={props.onChangeFilter}
                style={{marginBottom: "0.5rem"}}>
              </Checkbox>
              <Dropdown
                clearable={true}
                disabled={!props.ORCaseListSequence?.orFilter?.checkedRoom}
                fluid={true}
                id="CardORCaseListUX-Dropdown-89"
                name="operating_detail__operating_room__id"
                onChange={props.onChangeFilter}
                options={props.roomOptions || []}
                search={true}
                selection={true}
                style={{minWidth: "100%", width: 0}}
                value={props.ORCaseListSequence?.orFilter?.operating_detail__operating_room__id || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardORCaseListUX-FormField-83"
              style={{minWidth: "max-content"}}>
              <label
                id="CardORCaseListUX-label-97"
                style={{marginBottom: "0.5rem"}}>
                {"\u00a0"}
              </label>
              <div
                id="CardORCaseListUX-div-104">
                {props.buttonSearch}
              </div>
            </FormField>
            <FormField
              id="CardORCaseListUX-FormField-94"
              style={{minWidth: "max-content"}}>
              <label
                id="CardORCaseListUX-label-98"
                style={{marginBottom: "0.5rem"}}>
                {"\u00a0"}
              </label>
              <div
                id="CardORCaseListUX-div-103">
                {props.buttonPrint}
              </div>
            </FormField>
            <FormField
              id="CardORCaseListUX-FormField-95"
              style={{minWidth: "max-content"}}>
              <label
                id="CardORCaseListUX-label-99"
                style={{marginBottom: "0.5rem"}}>
                {"\u00a0"}
              </label>
              <div
                id="CardORCaseListUX-div-102">
                {props.buttonStat}
              </div>
            </FormField>
            <FormField
              id="CardORCaseListUX-FormField-96"
              style={{minWidth: "max-content"}}>
              <label
                id="CardORCaseListUX-label-100"
                style={{marginBottom: "0.5rem"}}>
                {"\u00a0"}
              </label>
              <div
                id="CardORCaseListUX-div-101">
                {props.buttonPrintStat}
              </div>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardORCaseListUX-div-22"
          style={{ display: props.showStatistic ? "none" : "" }}>
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.ORCaseListSequence?.caseList?.items || []}
            headers={props.languageUX === "en" ? "Date of Surgery, HN, Patient Name, Age, Cases, Location/Room, Surgeon, Operation, Anesthesia " : "วันที่ผ่าตัด, HN, ชื่อ - สกุลผู้ป่วย, อายุ, Cases, สถานที่/ห้อง, แพทย์ผ่าตัด, Operation, Anesthesia"}
            id="CardORCaseListUX-Table-33"
            keys="start_date, hn, patient_name, patient_age, caseText, locationRoom, primary_doctor_name, pre_operation_summary, anesthesia_method_name"
            minRows={10}
            showPagination={false}
            style={{height: "calc(100dvh - 21rem)"}}
            widths="^100,^80,^100,^60,^60,^120,^100,^140,^80">
          </Table>
        </div>
        <div
          id="CardORCaseListUX-div-55"
          style={{  display: props.showStatistic ? "" : "none" }}>
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.ORCaseListSequence?.statCaseList || []}
            headers="Location/Room, Cases, Anesthesia, Age range, Gender, QTY"
            id="CardORCaseListUX-Table-56"
            keys="locationRoom, caseText, anesthesia_method_name, ageRangeText, gender, count"
            minRows={10}
            style={{height: "calc(100dvh - 21rem)"}}
            widths="^180,^100,^100,^100,^100,^100">
          </Table>
        </div>
      </div>
    )
}


export default CardORCaseListUX

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Fri Oct 31 2025 04:20:16 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseList"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"15px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.showStatistic ? \"none\" : \"\" }"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 33,
      "name": "Table",
      "parent": 22,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.ORCaseListSequence?.caseList?.items || []"
        },
        "headers": {
          "type": "value",
          "value": "วันที่ผ่าตัด, HN, ชื่อ - สกุลผู้ป่วย, อายุ, Cases, สถานที่/ห้อง, แพทย์ผ่าตัด, Operation, Anesthesia",
          "valueEN": "Date of Surgery, HN, Patient Name, Age, Cases, Location/Room, Surgeon, Operation, Anesthesia "
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-Table-33"
        },
        "keys": {
          "type": "value",
          "value": "start_date, hn, patient_name, patient_age, caseText, locationRoom, primary_doctor_name, pre_operation_summary, anesthesia_method_name"
        },
        "minRows": {
          "type": "code",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"calc(100dvh - 21rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": "^100,^80,^100,^60,^60,^120,^100,^140,^80"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{  display: props.showStatistic ? \"\" : \"none\" }"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 56,
      "name": "Table",
      "parent": 55,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.ORCaseListSequence?.statCaseList || []"
        },
        "headers": {
          "type": "value",
          "value": "Location/Room, Cases, Anesthesia, Age range, Gender, QTY"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-Table-56"
        },
        "keys": {
          "type": "value",
          "value": "locationRoom, caseText, anesthesia_method_name, ageRangeText, gender, count"
        },
        "minRows": {
          "type": "code",
          "value": "10"
        },
        "style": {
          "type": "code",
          "value": "{height: \"calc(100dvh - 21rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": "^180,^100,^100,^100,^100,^100"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-Form-57"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "FormGroup",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-FormGroup-58"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormGroup",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-FormGroup-59"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormField",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-FormField-60"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "FormField",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-FormField-61"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "FormField",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-FormField-62"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormField",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-FormField-63"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "FormField",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-FormField-64"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "FormField",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-FormField-65"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormField",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-FormField-66"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "Checkbox",
      "parent": 60,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ORCaseListSequence?.orFilter?.checkedHn"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-Checkbox-67"
        },
        "label": {
          "type": "value",
          "value": "HN",
          "valueEN": "HN"
        },
        "name": {
          "type": "value",
          "value": "checkedHn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        },
        "toggle": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "Checkbox",
      "parent": 62,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ORCaseListSequence?.orFilter?.checkedDate"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-Checkbox-68"
        },
        "label": {
          "type": "value",
          "value": "วันที่ผ่าตัด",
          "valueEN": "Date of Surgery"
        },
        "name": {
          "type": "value",
          "value": "checkedDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "label",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ-สกุลผู้ป่วย",
          "valueEN": "Patient Name"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-label-69"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 60,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-div-70"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 62,
      "props": {
        "children": {
          "type": "code",
          "value": "props.startDateTextBox"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-div-71"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "Input",
      "parent": 61,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-Input-72"
        },
        "style": {
          "type": "code",
          "value": "{opacity: 1}"
        },
        "value": {
          "type": "code",
          "value": "props.ORCaseListSequence?.orFilter?.patientFullName || \"\""
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "label",
      "parent": 63,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-label-73"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "label",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-label-74"
        },
        "style": {
          "type": "code",
          "value": "{height: \"100%\", display: \"flex\", alignItems: \"center\", marginTop: \"-0.75rem\"}"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "label",
      "parent": 64,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-label-75"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "div",
      "parent": 64,
      "props": {
        "children": {
          "type": "code",
          "value": "props.endDateTextBox"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-div-76"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "Checkbox",
      "parent": 65,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ORCaseListSequence?.orFilter?.checkedDoctor"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-Checkbox-77"
        },
        "label": {
          "type": "value",
          "value": "แพทย์ผ่าตัด",
          "valueEN": "Surgeon"
        },
        "name": {
          "type": "value",
          "value": "checkedDoctor"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 65,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-div-78"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "Button",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างการค้นหา",
          "valueEN": "Clear"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-Button-79"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClear"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "FormField",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-FormField-80"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "FormField",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-FormField-81"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "FormField",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-FormField-82"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "FormField",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-FormField-83"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "Dropdown",
      "parent": 80,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.ORCaseListSequence?.orFilter?.checkedCase"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-Dropdown-87"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "cases"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "[ { key: \"is_opd_case\", value: \"is_opd_case\", text: \"OPD\" }, { key: \"is_ipd_case\", value: \"is_ipd_case\", text: \"IPD\" }, { key: \"is_one_day_case\", value: \"is_one_day_case\", text: \"One Day\", }, ]"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"100%\", width: 0}"
        },
        "value": {
          "type": "code",
          "value": "props.ORCaseListSequence?.orFilter?.cases || \"\""
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "Dropdown",
      "parent": 81,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.ORCaseListSequence?.orFilter?.checkedLocation"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-Dropdown-88"
        },
        "name": {
          "type": "value",
          "value": "operating_detail__operating_room__location_id"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeLocation"
        },
        "options": {
          "type": "code",
          "value": "props.locationOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"100%\", width: 0}"
        },
        "value": {
          "type": "code",
          "value": "props.ORCaseListSequence?.orFilter?.operating_detail__operating_room__location_id || \"\""
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "Dropdown",
      "parent": 82,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.ORCaseListSequence?.orFilter?.checkedRoom"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-Dropdown-89"
        },
        "name": {
          "type": "value",
          "value": "operating_detail__operating_room__id"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.roomOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"100%\", width: 0}"
        },
        "value": {
          "type": "code",
          "value": "props.ORCaseListSequence?.orFilter?.operating_detail__operating_room__id || \"\""
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "FormField",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-FormField-94"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "FormField",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-FormField-95"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "FormField",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-FormField-96"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "label",
      "parent": 83,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-label-97"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "label",
      "parent": 94,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-label-98"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "label",
      "parent": 95,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-label-99"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "label",
      "parent": 96,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-label-100"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "div",
      "parent": 96,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrintStat"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-div-101"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 95,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonStat"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-div-102"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-div-103"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 83,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-div-104"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "Checkbox",
      "parent": 80,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ORCaseListSequence?.orFilter?.checkedCase"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-Checkbox-105"
        },
        "label": {
          "type": "value",
          "value": "Case",
          "valueEN": "Case"
        },
        "name": {
          "type": "value",
          "value": "checkedCase"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "Checkbox",
      "parent": 81,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ORCaseListSequence?.orFilter?.checkedLocation"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-Checkbox-106"
        },
        "label": {
          "type": "value",
          "value": "Location",
          "valueEN": "Location"
        },
        "name": {
          "type": "value",
          "value": "checkedLocation"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "Checkbox",
      "parent": 82,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.ORCaseListSequence?.orFilter?.checkedRoom"
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-Checkbox-107"
        },
        "label": {
          "type": "value",
          "value": "ห้อง",
          "valueEN": "Room"
        },
        "name": {
          "type": "value",
          "value": "checkedRoom"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "label",
      "parent": 66,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardORCaseListUX-label-108"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 79,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardORCaseListUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 80
}

*********************************************************************************** */
